"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.split = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var split = function split(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'split-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M16.75 15.9523C16.75 16.3665 16.4142 16.7023 16 16.7023L10.5 16.7023C9.5335 16.7023 8.75 15.9188 8.75 14.9523L8.74999 6.95227C8.74999 5.98577 9.5335 5.20227 10.5 5.20227L16 5.20227C16.4142 5.20227 16.75 5.53806 16.75 5.95227C16.75 6.36648 16.4142 6.70227 16 6.70227L10.5 6.70227C10.3619 6.70227 10.25 6.8142 10.25 6.95227L10.25 14.9523C10.25 15.0903 10.3619 15.2023 10.5 15.2023L16 15.2023C16.4142 15.2023 16.75 15.5381 16.75 15.9523Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M14.5315 3.36662C14.8549 3.10786 15.3269 3.1603 15.5857 3.48375L17.1857 5.48375C17.4048 5.75766 17.4048 6.14687 17.1857 6.42079L15.5857 8.42079C15.3269 8.74424 14.8549 8.79668 14.5315 8.53792C14.208 8.27916 14.1556 7.80719 14.4143 7.48375L15.6395 5.95227L14.4143 4.42079C14.1556 4.09734 14.208 3.62537 14.5315 3.36662Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M14.5315 13.3666C14.8549 13.1079 15.3269 13.1603 15.5857 13.4837L17.1857 15.4837C17.4048 15.7577 17.4048 16.1469 17.1857 16.4208L15.5857 18.4208C15.3269 18.7442 14.8549 18.7967 14.5315 18.5379C14.208 18.2792 14.1556 17.8072 14.4143 17.4837L15.6395 15.9523L14.4143 14.4208C14.1556 14.0973 14.208 13.6254 14.5315 13.3666Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M2.25 10.9523C2.25 10.5381 2.58579 10.2023 3 10.2023H9C9.41421 10.2023 9.75 10.5381 9.75 10.9523C9.75 11.3665 9.41421 11.7023 9 11.7023H3C2.58579 11.7023 2.25 11.3665 2.25 10.9523Z',
    fill: '#4B5563'
  }));
};

exports.split = split;